export { SingleDescriptor as default } from './SingleDescriptor';
